"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMessanger = function SvgMessanger(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    className: "messanger_svg__menu-messanger",
    viewBox: "0 0 24 24",
    fill: "#fff",
    stroke: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m5.306 18.94.497-.054a.5.5 0 0 0-.411-.439l-.086.493ZM5 22l-.474-.158a.5.5 0 0 0 .828.512L5 22Zm3.404-3v-.5a.5.5 0 0 0-.323.118l.323.382ZM2.5 7A3.5 3.5 0 0 1 6 3.5v-1A4.5 4.5 0 0 0 1.5 7h1Zm0 8V7h-1v8h1Zm2.892 3.447A3.501 3.501 0 0 1 2.5 15h-1a4.501 4.501 0 0 0 3.72 4.433l.172-.986Zm.082 3.711c.296-.888.435-2.284.329-3.272l-.994.108c.092.855-.036 2.105-.283 2.848l.948.316Zm2.607-3.54c-1.1.928-2.751 2.345-3.435 3.028l.708.708c.646-.647 2.26-2.034 3.372-2.972l-.645-.764ZM18 18.5H8.404v1H18v-1Zm3.5-3.5a3.5 3.5 0 0 1-3.5 3.5v1a4.5 4.5 0 0 0 4.5-4.5h-1Zm0-8v8h1V7h-1ZM18 3.5A3.5 3.5 0 0 1 21.5 7h1A4.5 4.5 0 0 0 18 2.5v1Zm-12 0h12v-1H6v1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8h12M6 11h12M6 14h8.5"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMessanger);
var _default = exports["default"] = Memo;